/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class EquipmentAttachmentService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'EquipmentAttachmentService\' loaded');
    }
}

export { EquipmentAttachmentService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/equipment/service/EquipmentAttachmentService.js